"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarItem = exports.CalendarGroup = exports.CalendarNavigation = exports.CalendarHeader = void 0;
var react_1 = __importDefault(require("react"));
var react_calendar_timeline_1 = __importStar(require("react-calendar-timeline"));
var CalendarHeader_1 = __importDefault(require("./CalendarHeader"));
var Group_1 = __importDefault(require("./Group"));
var Item_1 = __importDefault(require("./Item"));
var CalendarHeader_2 = require("./CalendarHeader");
Object.defineProperty(exports, "CalendarHeader", { enumerable: true, get: function () { return __importDefault(CalendarHeader_2).default; } });
var CalendarNavigation_1 = require("./CalendarNavigation");
Object.defineProperty(exports, "CalendarNavigation", { enumerable: true, get: function () { return __importDefault(CalendarNavigation_1).default; } });
var Group_2 = require("./Group");
Object.defineProperty(exports, "CalendarGroup", { enumerable: true, get: function () { return __importDefault(Group_2).default; } });
var Item_2 = require("./Item");
Object.defineProperty(exports, "CalendarItem", { enumerable: true, get: function () { return __importDefault(Item_2).default; } });
exports.default = (function (props) {
    var rowClassNames = function (group) {
        var classNames = [];
        if (props.withSubGroups && group.childrens) {
            classNames.push("root");
        }
        if (props.withSubGroups && !group.childrens) {
            classNames.push("subgroup");
        }
        if (group.open) {
            classNames.push("open");
        }
        if (group.open && group.childrens && !group.childrens.length) {
            classNames.push("empty");
        }
        return classNames;
    };
    var groupRender = function (groupProps) {
        var onGroupClick = props.onGroupClick, withSubGroups = props.withSubGroups, groupRenderer = props.groupRenderer;
        return react_1.default.createElement(Group_1.default, __assign({}, groupProps, { withSubGroups: withSubGroups, groupContent: groupRenderer, onClick: onGroupClick }));
    };
    var itemRender = function (itemProps) {
        // tslint:disable-next-line:no-shadowed-variable
        var itemRenderer = props.itemRenderer, onItemClick = props.onItemClick, itemHeightRatio = props.itemHeightRatio;
        return react_1.default.createElement(Item_1.default, __assign({ onClick: onItemClick, itemRenderer: itemRenderer, itemHeightRatio: itemHeightRatio }, itemProps));
    };
    var unit = props.unit, onItemClick = props.onItemClick, horizontalLineClassNamesForGroup = props.horizontalLineClassNamesForGroup, rest = __rest(props, ["unit", "onItemClick", "horizontalLineClassNamesForGroup"]);
    return (react_1.default.createElement(react_calendar_timeline_1.default, __assign({}, rest, { itemRenderer: itemRender, groupRenderer: groupRender, horizontalLineClassNamesForGroup: rowClassNames }),
        react_1.default.createElement(react_calendar_timeline_1.TimelineHeaders, null,
            react_1.default.createElement(CalendarHeader_1.default, { unit: unit, height: 50 }),
            react_1.default.createElement(CalendarHeader_1.default, { unit: unit !== "year" ? "day" : "month", className: "secondary" })),
        react_1.default.createElement(react_calendar_timeline_1.TodayMarker, { interval: 200000, date: new Date() })));
});
//# sourceMappingURL=index.js.map